import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import AddOnPage from './AddOnPage';
import useDetailForAddOnState from './useDetailForAddOnState';
import Loader from '../../../../../ui-kitchen/src/components/Loader';
import IframeHostContext from '../../contexts/iframeHost';

const AddOnPageController = (props) => {
  const {
    Analytics,
    backPath,
    bookingState,
    selectedDate,
    selectedQuantity,
    setItems,
    templates,
    venue,
  } = props;
  const iframeHost = useContext(IframeHostContext);
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const { templateId } = useParams();
  const { detailForAddons, menu } = useDetailForAddOnState({
    bookingState,
    selectedDate,
    selectedQuantity,
    templateId,
    templates,
    venue,
  });
  const viewPortHeight = +iframeHost.getDimensions().innerHeight;
  const clearMessages = () => setMessages([]);

  // exit early back to venue details
  if (menu) {
    const {
      out_of_stock: outOfStock,
      max_party_size: maxPartySize,
    } = menu;
    if (outOfStock || (maxPartySize && maxPartySize < selectedQuantity)) {
      navigate(`/venues/${venue.id}`);
    }
  }
  return (detailForAddons && menu)
    ? (
      <AddOnPage
        Analytics={Analytics}
        backPath={backPath}
        clearError={clearMessages}
        detail={detailForAddons}
        errors={messages}
        items={bookingState.items}
        menu={menu}
        quantity={selectedQuantity}
        setItems={setItems}
        viewPortHeight={viewPortHeight}
        navigate={navigate}
      />
    ) : <Loader />;
};

AddOnPageController.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  backPath: PropTypes.string,
  bookingState: PropTypes.shape({
    items: PropTypes.shape({}),
  }).isRequired,
  selectedDate: PropTypes.instanceOf(Date).isRequired,
  selectedQuantity: PropTypes.number.isRequired,
  setItems: PropTypes.func.isRequired,
  templates: PropTypes.shape({}).isRequired,
  venue: PropTypes.shape({ id: PropTypes.number }),
};

AddOnPageController.defaultProps = {
  backPath: '',
  venue: {},
};

export default AddOnPageController;
